module.exports = __webpack_public_path__ + "static/media/po-lub-2.a0f0fc15.png";